// components/CustomTypography.jsx
import React from "react";
import { Typography } from "@mui/material";

const TitreTypography = ({ children, sx = {} }) => {
  return (
    <Typography
      sx={{
        fontWeight: "bold",
        fontFamily: "F37Ginger-Bold, sans-serif",
        ...sx, // merge with custom styles passed as prop
      }}
    >
      {children}
    </Typography>
  );
};

export default TitreTypography;
